declare var parametriApplicativi: any;

export class AppProperties {
  public static VERSION = "2.1.0";
  public static PASSWORD_MINLENGTH = 10;
  public static NAME_MAXLENGTH = 100;
  public static DESCRIPTION_MAXLENGTH = 200;
  public static BASEURL = parametriApplicativi.BASEURL;
  public static URL_REDIRECT_LOGOUT = parametriApplicativi.URL_REDIRECT_LOGOUT;
}



// WEBPACK FOOTER //
// ./src/app/app-properties.ts